import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "proposal-list__-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CreateIcon = _resolveComponent("CreateIcon")!
  const _component_NcActionButton = _resolveComponent("NcActionButton")!
  const _component_NcAppNavigationCaption = _resolveComponent("NcAppNavigationCaption")!
  const _component_WarningIcon = _resolveComponent("WarningIcon")!
  const _component_NcAppNavigationItem = _resolveComponent("NcAppNavigationItem")!
  const _component_VotingIcon = _resolveComponent("VotingIcon")!
  const _component_CompleteIcon = _resolveComponent("CompleteIcon")!
  const _component_PendingIcon = _resolveComponent("PendingIcon")!
  const _component_NcCounterBubble = _resolveComponent("NcCounterBubble")!
  const _component_ViewIcon = _resolveComponent("ViewIcon")!
  const _component_ModifyIcon = _resolveComponent("ModifyIcon")!
  const _component_DestroyIcon = _resolveComponent("DestroyIcon")!
  const _component_NcDialog = _resolveComponent("NcDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NcAppNavigationCaption, {
      class: "proposal-list__caption",
      name: $options.t('calendar', 'Meeting proposals')
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_NcActionButton, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.onProposalCreate()))
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_CreateIcon, {
              size: 20,
              decorative: ""
            })
          ]),
          default: _withCtx(() => [
            _createTextVNode(" " + _toDisplayString($options.t('calendar', 'Create new')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["name"]),
    (!$options.userHasEmailAddress)
      ? (_openBlock(), _createBlock(_component_NcAppNavigationItem, {
          key: 0,
          name: $options.t('calendar', 'A configured email address is required to use meeting proposals'),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.window.open($options.generateUrl('settings/user'), '_blank').focus()))
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_WarningIcon, { size: 20 })
          ]),
          _: 1
        }, 8, ["name"]))
      : _createCommentVNode("", true),
    ($options.userHasEmailAddress)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          ($data.storedProposals.length === 0)
            ? (_openBlock(), _createBlock(_component_NcAppNavigationItem, {
                key: 0,
                name: $options.t('calendar', 'No active meeting proposals'),
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.onProposalCreate()))
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_VotingIcon, { size: 20 })
                ]),
                _: 1
              }, 8, ["name"]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.storedProposals, (proposal) => {
            return (_openBlock(), _createBlock(_component_NcAppNavigationItem, {
              key: proposal.id,
              name: proposal.title,
              class: "proposal-list__item",
              onClick: ($event: any) => ($options.onProposalView(proposal))
            }, _createSlots({
              counter: _withCtx(() => [
                _createVNode(_component_NcCounterBubble, {
                  count: `${$options.proposalParticipantsResponded(proposal)}/${$options.proposalParticipantsTotal(proposal)}`,
                  raw: true
                }, null, 8, ["count"])
              ]),
              actions: _withCtx(() => [
                _createVNode(_component_NcActionButton, {
                  closeAfterClick: true,
                  onClick: ($event: any) => ($options.onProposalView(proposal))
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_ViewIcon, { size: 20 })
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString($options.t('calendar', 'View')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_NcActionButton, {
                  closeAfterClick: true,
                  onClick: ($event: any) => ($options.onProposalModify(proposal))
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_ModifyIcon, { size: 20 })
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString($options.t('calendar', 'Edit')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_NcActionButton, {
                  closeAfterClick: true,
                  onClick: ($event: any) => ($options.onProposalDestroy(proposal))
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_DestroyIcon, { size: 20 })
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString($options.t('calendar', 'Delete')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 2
            }, [
              ($options.proposalParticipantsTotal(proposal) === $options.proposalParticipantsResponded(proposal))
                ? {
                    name: "icon",
                    fn: _withCtx(() => [
                      _createVNode(_component_CompleteIcon, {
                        size: 20,
                        decorative: "",
                        class: "proposal-list__icon--complete"
                      })
                    ]),
                    key: "0"
                  }
                : {
                    name: "icon",
                    fn: _withCtx(() => [
                      _createVNode(_component_PendingIcon, {
                        size: 20,
                        decorative: ""
                      })
                    ]),
                    key: "1"
                  }
            ]), 1032, ["name", "onClick"]))
          }), 128))
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(_component_NcDialog, {
      open: $data.showDeleteDialog,
      name: $options.t('calendar', 'Delete proposal'),
      message: $options.deleteDialogMessage,
      buttons: $options.deleteDialogButtons,
      "onUpdate:open": _cache[3] || (_cache[3] = ($event: any) => ($data.showDeleteDialog = $event))
    }, null, 8, ["open", "name", "message", "buttons"])
  ]))
}